import * as React from "react";

/**
 * Trail a fast-changing value behind a delay.
 *
 * For deriving a query key from an input: without it, every keystroke is a
 * separate request and the answers can arrive out of order. The value settles
 * once the user pauses.
 */
export function useDebouncedValue<T>(value: T, delay: number): T {
	const [settled, setSettled] = React.useState(value);

	React.useEffect(() => {
		const timer = window.setTimeout(() => setSettled(value), delay);
		return () => window.clearTimeout(timer);
	}, [value, delay]);

	return settled;
}
